<app-funnel-shell>
  <div class="funnel-card funnel-result">
    @if (loading()) {
      <p class="funnel-card__intro">{{ 'funnel.result.loading' | translate }}</p>
    } @else {
      <div class="funnel-result__tag">{{ 'funnel.result.recommended_tag' | translate }}</div>
      <h1>{{ 'funnel.result.recommended_title' | translate: { plan: recommendedName() } }}</h1>
      <p class="funnel-card__intro">{{ 'funnel.result.recommended_intro' | translate }}</p>

      <form class="funnel-result__password" (ngSubmit)="submitPassword()" novalidate>
        <label class="funnel-result__label">{{ 'funnel.result.password_label' | translate }}</label>
        <input
          class="funnel-result__input"
          type="password"
          autocomplete="new-password"
          [placeholder]="'funnel.result.password_placeholder' | translate"
          [ngModel]="password()"
          (ngModelChange)="password.set($event)"
          name="password"
        />

        <label class="funnel-result__label">{{ 'funnel.result.confirm_label' | translate }}</label>
        <input
          class="funnel-result__input"
          type="password"
          autocomplete="new-password"
          [placeholder]="'funnel.result.confirm_placeholder' | translate"
          [ngModel]="confirm()"
          (ngModelChange)="confirm.set($event)"
          name="confirm"
        />

        <p class="funnel-result__hint">{{ 'funnel.result.password_rule' | translate: { min: minLength } }}</p>

        @if (pwError() === 'mismatch') {
          <div class="alert alert-danger" role="alert">{{ 'funnel.result.password_mismatch' | translate }}</div>
        } @else if (pwError()) {
          <div class="alert alert-danger" role="alert">{{ 'funnel.result.password_error' | translate }}</div>
        }

        <button cButton color="primary" type="submit" class="w-100 mt-2" [disabled]="!canSubmit()">
          {{ (busy() ? 'funnel.result.saving' : 'funnel.result.finish_cta') | translate }}
        </button>
      </form>

      <button
        type="button"
        class="funnel-result__back"
        [disabled]="busy()"
        (click)="goBackToQuiz()"
      >
        &larr; {{ 'funnel.quiz.back' | translate }}
      </button>
    }

    @if (error()) {
      <div class="alert alert-danger mt-3" role="alert">{{ error() }}</div>
    }
  </div>
</app-funnel-shell>
